var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-main"},[_c('list',{ref:"all",attrs:{"categoryOptions":_vm.categoryOptions,"virtualWarehouse":_vm.virtualWarehouse,"tabType":0}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }